// i18n configuration - translations v2
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import it from './locales/it.json';
import en from './locales/en.json';
import es from './locales/es.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      it: { translation: it },
      en: { translation: en },
      es: { translation: es },
    },
    supportedLngs: ['it', 'en', 'es'],
    load: 'languageOnly',
    nonExplicitSupportedLngs: false,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    missingKeyHandler: (lng, ns, key) => {
      console.warn(`[i18n] Missing translation: ${key} (${lng})`);
    },
  });

export default i18n;
